import React from 'react'
import PropTypes from 'prop-types'

import { WEIGHT } from '../../style/type'

import ReactHtmlParser from 'react-html-parser'
import { SliceSection } from '../common/Section'
import Text from '../common/Text'
import ResponsivePlayer from '../common/ResponsivePlayer'
import AspectRatioBox from '../common/AspectRatioBox'
import ConsentNotice from '../common/ConsentNotice'
import useConsent from '../../hooks/useConsent'

import styled, { css } from 'styled-components'
import { rem } from 'polished'
import { get } from 'lodash'

const VideoModule = ({ primary: data, ...props }) => {
  const video = get(data, 'video_url.url')
  const caption = get(data, 'video_caption.text')
  const coverImage = get(data, 'video_cover_image.url')
  const image = coverImage || true
  const bgColor = get(data, 'background_color') || 'transparent'

  // YouTube/Vimeo embeds set third-party cookies, so only mount the player
  // once the visitor has consented; otherwise show the cover image.
  const canPlay = useConsent('advertisement')

  return (
    <SliceSection bgColor={bgColor} {...props}>
      <Container>
        {video &&
          (canPlay ? (
            <ResponsivePlayer url={video} image={image} />
          ) : (
            <ConsentPlaceholder cover={coverImage} />
          ))}
        {caption && <Text.h5 center>{ReactHtmlParser(caption)}</Text.h5>}
      </Container>
    </SliceSection>
  )
}

const ConsentPlaceholder = ({ cover }) => (
  <AspectRatioBox width={16} height={9} border>
    <Placeholder cover={cover}>
      <ConsentNotice message="This video is hidden until you accept cookies." />
    </Placeholder>
  </AspectRatioBox>
)

ConsentPlaceholder.propTypes = {
  cover: PropTypes.string,
}

VideoModule.propTypes = {
  primary: PropTypes.object,
}

export default VideoModule

const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    min-height: ${rem(140)};
    width: 100%;
    max-width: ${theme.layout.maxWidth};
    overflow: hidden;

    h5 {
      margin-top: ${theme.space(1)};
      font-size: 11px;
      letter-spacing: 0.5px;
      line-height: 14px;
      font-weight: ${WEIGHT.BOLD};

      ${theme.media.lg`
        margin-top: ${theme.space(3)};
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 22px;
        font-weight: ${WEIGHT.MEDIUM};
      `};
    }
  `};
`

const Placeholder = styled.div`
  ${({ cover, theme }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.color.blue};
    background-size: cover;
    background-position: center;

    ${cover &&
      css`
        background-image: linear-gradient(
            rgba(29, 53, 91, 0.72),
            rgba(29, 53, 91, 0.72)
          ),
          url(${cover});
      `};
  `};
`
